import React, { Component, Fragment } from "react";
import "../../styles/Popup.module.css";
import {
  Form,
  Select,
  Input,
  Button,
  Steps,
  message,
  Switch,
  TimePicker,
  Tooltip,
} from "antd";
import {
  SmileOutlined,
  FieldTimeOutlined,
  CheckCircleOutlined,
} from "@ant-design/icons";
import { connect } from "react-redux";
import {
  requestServerPost,
  requestServerGet,
  selectPage,
  requestNodeServerPost,
} from "../../actions";
import { QuestionCircleOutlined } from "@ant-design/icons";
import PopupManager from "../../managers/PopupManager";
import CampaignSelector from "../CampaignSelector";
import DataHelper from "../../helpers/DataHelper";
import MomentHelper from "../../helpers/MomentHelper";
import moment from "moment";
import { Zap } from "lucide-react";
import {
  useProLanguage,
  PRO_TRANSLATIONS,
} from "../../global/ProLanguageContext";
const { Option } = Select;
const { Step } = Steps;

const steps = [
  {
    title: "Event Type",
    content: "First-content",
  },
  {
    title: "Content",
    content: "Second-content",
  },
  {
    title: "Settings",
    content: "Third-content",
  },
  {
    title: "Complete",
    content: "Last-content",
  },
];

const formItemLayout = {
  labelCol: { span: 0 },
  wrapperCol: { span: 24 },
};

//Use LabelWithTooltip as Form.Item native tooltip somehow doesn't seem to work
const LabelWithTooltip = ({ label, tooltip }) => {
  return (
    <span>
      {label}
      <Tooltip title={tooltip}>
        <QuestionCircleOutlined
          style={{ marginLeft: "8px", color: "#00000073", cursor: "pointer" }}
        />
      </Tooltip>
    </span>
  );
};

class CreateScreenEventPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fileList: [],
      currentStep: 0,
      eventTypes: [],
      formData: {},
      playlistDatas: [],
    };
  }

  componentDidUpdate(prev) {
    if (prev.data !== this.props.data && this.props.data) {
      var currentFormData = { ...this.props.data };
      // if ("allowInterrupt" in currentFormData) {
      //     this.setState({ allowInterrupt: currentFormData.allowInterrupt })
      // }
      // else {
      //     currentFormData.allowInterrupt = this.state.allowInterrupt;
      // }
      // if ("duration" in currentFormData) {
      //     this.setState({ duration: currentFormData.duration })
      // }
      // else {
      //     currentFormData.duration = this.state.duration;
      // }
      // if ("delayafter" in currentFormData) {
      //     this.setState({ delayafter: currentFormData.delayafter })
      // }
      // else {
      //     currentFormData.delayafter = this.state.delayafter;
      // }

      this.setState({ formData: { ...currentFormData } });
    }
  }
  componentDidMount() {
    if (this.props.data) {
      var currentFormData = { ...this.props.data };

      this.setState({ formData: { ...currentFormData } });
    }

    this.getEventTypes();
    this.getPlaylists();
  }

  next = () => {
    const currentStep = this.state.currentStep + 1;
    this.setState({ currentStep });
  };

  prev = () => {
    const currentStep = this.state.currentStep - 1;
    this.setState({ currentStep });
  };

  // onFinish = values => {
  //     const { requestServerPost, requestNodeServerPost, usertoken, selectedBrandData, selectedBranchData, data } = this.props;
  //     var params = new URLSearchParams();

  //     params.append("brand", selectedBrandData.BrandID);
  //     params.append("mall", selectedBranchData.BranchID);
  //     params.append("unit", values.screenname);
  //     params.append("code", values.pairingcode);

  //     if (data) {
  //         this.updateScreen();
  //         return;
  //     }
  //     requestNodeServerPost("attemptscreenpairing", params, { 'Content-Type': 'application/x-www-form-urlencoded' }, (response) => {

  //         // console.log("create brand success")
  //         // PopupManager.closePopup();

  //         console.log("DONE " + response)

  //         this.next();
  //         // requestServerPost("create_screen", params, { }, (response) => {

  //         //     // console.log("create brand success")
  //         //     PopupManager.closePopup();
  //         // }, usertoken);
  //     }, usertoken);
  // };

  getEventTypes = () => {
    // console.log("valuesvaluesvalues " + JSON.stringify(values))
    const { requestServerGet, usertoken } = this.props;
    var params = new FormData();

    // console.log("updateScreen " + values)
    requestServerGet(
      "get_eventtypes",
      {},
      null,
      (response) => {
        console.log("Event Types " + JSON.stringify(response));
        this.setState({ eventTypes: response.data });
      },
      usertoken,
    );
  };

  getPlaylists = () => {
    const { selectedBrandData, selectedBranchData } = this.props;

    if (selectedBrandData && selectedBranchData) {
      DataHelper.getPlaylists(
        {
          brandid: selectedBrandData.BrandID,
          branchid: selectedBranchData.BranchID,
        },
        this.props,
      ).then((plDatas) => {
        console.log("plDatas " + JSON.stringify(plDatas));
        this.setState({ playlistDatas: plDatas });
      });
    }
  };

  prepareParams = (formdata) => {
    const { selectedBrandData, selectedBranchData } = this.props;
    var newParams = {};
    Object.keys(formdata).forEach((k) => {
      newParams[k.toLowerCase()] = formdata[k];
    });

    newParams.brandid = selectedBrandData.BrandID;
    newParams.branchid = selectedBranchData.BranchID;

    return newParams;
  };

  onUsePlaylistDurationClicked = () => {
    this.applyPlaylistDuration();
  };

  applyPlaylistDuration = () => {
    const plduration = this.getPlaylistDuration(this.state.formData.PlaylistID);
    this.updateCurrentSettings({ duration: plduration });
  };

  getPlaylistDuration = (playlistID) => {
    const selectedPlaylistData = this.state.playlistDatas.find((pdat) => {
      return playlistID === pdat.PlaylistID;
    });

    let pDuration = 0;

    console.log("getPlaylistDuration " + JSON.stringify(selectedPlaylistData));
    selectedPlaylistData.Medias.forEach((media) => {
      if (media.MediaStatus === 2) {
        const expirationStatus = MomentHelper.checkItemExpiration(media);
        if (expirationStatus === 0) {
          pDuration += media.Duration;
          console.log("add duration " + media.Duration);
        }
      }
    });

    console.log("pDuration " + pDuration);
    return pDuration;
  };

  updateCurrentSettings = (newUpdate) => {
    const newFormData = this.state.formData ? { ...this.state.formData } : {};
    const oldSettings = newFormData.Settings
      ? { ...JSON.parse(newFormData.Settings) }
      : {};
    const newSettings = { ...oldSettings, ...newUpdate };
    newFormData.Settings = JSON.stringify(newSettings);
    console.log("newSettings " + newSettings);
    this.setState({ formData: newFormData });
  };

  updateCurrentFormData = (newUpdate) => {
    const oldFormData = this.state.formData ? { ...this.state.formData } : {};
    const newFormData = { ...oldFormData, ...newUpdate };
    this.setState({ formData: newFormData });
  };

  render() {
    const { currentStep } = this.state;
    const isEdit = !!this.props.data;

    const bleed = { margin: -24, overflow: "hidden" };
    const body = { maxWidth: 460, margin: "0 auto", padding: "28px 40px 32px" };
    const labelStyle = {
      fontSize: 12,
      fontWeight: 600,
      color: "#64748b",
      textTransform: "uppercase",
      letterSpacing: "0.05em",
      display: "block",
      marginBottom: 6,
    };
    const submitBtn = {
      width: "100%",
      height: 48,
      borderRadius: 10,
      border: "none",
      background: "linear-gradient(135deg,#6366f1,#4f46e5)",
      color: "#fff",
      fontSize: 15,
      fontWeight: 600,
      cursor: "pointer",
      boxShadow: "0 2px 10px rgba(99,102,241,0.3)",
      marginTop: 8,
    };
    const secondaryBtn = {
      height: 40,
      borderRadius: 10,
      border: "1.5px solid #e2e8f0",
      background: "#fff",
      color: "#64748b",
      fontSize: 14,
      fontWeight: 500,
      cursor: "pointer",
      padding: "0 20px",
      marginRight: 8,
    };

    const t = this.props.langT || PRO_TRANSLATIONS.en.createScreenEvent;

    const stepHeaders = [
      { title: isEdit ? t.editTitle : t.createTitle, subtitle: t.subtitle },
      { title: t.selectContentTitle, subtitle: t.selectContentSubtitle },
      { title: t.settingsTitle, subtitle: t.settingsSubtitle },
      {
        title: isEdit ? t.eventUpdatedTitle : t.eventCreatedTitle,
        subtitle: t.doneSubtitle,
      },
    ];

    const LabelWithTooltip = ({ label, tooltip }) => (
      <span style={labelStyle}>
        {label}
        <Tooltip title={tooltip}>
          <QuestionCircleOutlined
            style={{ marginLeft: 6, color: "#94a3b8", cursor: "pointer" }}
          />
        </Tooltip>
      </span>
    );

    const renderStepContent = () => {
      switch (currentStep) {
        case 1: {
          return (
            <div style={body}>
              <label style={labelStyle}>{t.playlistLabel}</label>
              <Select
                size="large"
                style={{ width: "100%", borderRadius: 10 }}
                placeholder={t.playlistPlaceholder}
                value={this.state.formData?.PlaylistID}
                onChange={(value) => {
                  const newFormData = {
                    ...this.state.formData,
                    PlaylistID: value,
                  };
                  const sec = this.getPlaylistDuration(value);
                  const oldSettings = newFormData.Settings
                    ? JSON.parse(newFormData.Settings)
                    : {};
                  newFormData.Settings = JSON.stringify({
                    ...oldSettings,
                    duration: sec,
                  });
                  this.setState({ formData: newFormData });
                }}
              >
                {this.state.playlistDatas.map((pd) => (
                  <Select.Option key={pd.PlaylistID} value={pd.PlaylistID}>
                    {pd.PlaylistName}
                  </Select.Option>
                ))}
              </Select>
              <div style={{ display: "flex", marginTop: 24, gap: 8 }}>
                <button style={secondaryBtn} onClick={this.prev}>
                  {t.back}
                </button>
                <button
                  style={{ ...submitBtn, flex: 1, marginTop: 0 }}
                  onClick={() => {
                    if ("PlaylistID" in this.state.formData) this.next();
                    else message.error(t.errNoPlaylist);
                  }}
                >
                  {t.next}
                </button>
              </div>
            </div>
          );
        }
        case 2: {
          const settingsObj = this.state.formData?.Settings
            ? JSON.parse(this.state.formData.Settings)
            : { allowInterrupt: false, duration: 0, delayAfter: 0 };
          const momentDuration = moment(
            MomentHelper.convertDurationToTimeFormat(settingsObj.duration),
            "HH:mm:ss",
          );
          const momentDelayAfter = moment(
            MomentHelper.convertDurationToTimeFormat(settingsObj.delayAfter),
            "HH:mm:ss",
          );
          const shouldDisablePlaylistDurationBTN =
            settingsObj.duration ===
            this.getPlaylistDuration(this.state.formData?.PlaylistID);

          return (
            <div style={body}>
              <div style={{ marginBottom: 20 }}>
                <LabelWithTooltip
                  label={t.allowInterrupt}
                  tooltip={t.allowInterruptTooltip}
                />
                <Switch
                  defaultChecked={!!settingsObj.allowInterrupt}
                  onChange={(v) =>
                    this.updateCurrentSettings({ allowInterrupt: v })
                  }
                />
              </div>
              <div style={{ marginBottom: 20 }}>
                <LabelWithTooltip
                  label={t.playDuration}
                  tooltip={t.playDurationTooltip}
                />
                <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                  <TimePicker
                    showNow={false}
                    allowClear={false}
                    value={momentDuration}
                    onChange={(v) =>
                      this.updateCurrentSettings({
                        duration: MomentHelper.getSecondsDuration(v),
                      })
                    }
                    size="large"
                    style={{ flex: 1, borderRadius: 10 }}
                  />
                  <Button
                    disabled={shouldDisablePlaylistDurationBTN}
                    onClick={this.onUsePlaylistDurationClicked}
                    icon={<FieldTimeOutlined />}
                    shape="round"
                    size="small"
                    type="dashed"
                  >
                    {t.usePlaylist}
                  </Button>
                </div>
              </div>
              <div style={{ marginBottom: 24 }}>
                <LabelWithTooltip
                  label={t.delayAfter}
                  tooltip={t.delayAfterTooltip}
                />
                <TimePicker
                  showNow={false}
                  allowClear={false}
                  value={momentDelayAfter}
                  onChange={(v) =>
                    this.updateCurrentSettings({
                      delayAfter: MomentHelper.getSecondsDuration(v),
                    })
                  }
                  size="large"
                  style={{ width: "100%", borderRadius: 10 }}
                />
              </div>
              <div style={{ display: "flex", gap: 8 }}>
                <button style={secondaryBtn} onClick={this.prev}>
                  {t.back}
                </button>
                <button
                  style={{ ...submitBtn, flex: 1, marginTop: 0 }}
                  onClick={() => {
                    const { requestServerPost, usertoken } = this.props;
                    const preparedParams = this.prepareParams(
                      this.state.formData,
                    );
                    const endpoint = isEdit
                      ? "update_eventplaylist"
                      : "create_eventplaylist";
                    requestServerPost(
                      endpoint,
                      preparedParams,
                      {},
                      () => this.next(),
                      usertoken,
                    );
                  }}
                >
                  {isEdit ? t.saveChanges : t.createBtn}
                </button>
              </div>
            </div>
          );
        }
        case 3: {
          return (
            <div style={{ ...body, textAlign: "center", paddingTop: 40 }}>
              <div
                style={{
                  width: 64,
                  height: 64,
                  borderRadius: 18,
                  background: "linear-gradient(135deg,#f0fdf4,#dcfce7)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  margin: "0 auto 16px",
                }}
              >
                <CheckCircleOutlined
                  style={{ fontSize: 30, color: "#16a34a" }}
                />
              </div>
              <div
                style={{
                  fontSize: 18,
                  fontWeight: 700,
                  color: "#0f172a",
                  marginBottom: 8,
                }}
              >
                {isEdit ? "Event Updated!" : "Event Created!"}
              </div>
              <div style={{ fontSize: 13, color: "#94a3b8", marginBottom: 28 }}>
                {t.readyText}
              </div>
              <button style={submitBtn} onClick={PopupManager.closePopup}>
                {t.done}
              </button>
            </div>
          );
        }
        default: {
          return (
            <div style={body}>
              <label style={labelStyle}>{t.eventNameLabel}</label>
              <Input
                size="large"
                style={{ borderRadius: 10, marginBottom: 20 }}
                placeholder={t.eventNamePlaceholder}
                defaultValue={this.props.data?.EventPlaylistName}
                onChange={(e) =>
                  this.updateCurrentFormData({
                    EventPlaylistName: e.target.value,
                  })
                }
              />
              <label style={labelStyle}>{t.eventTypeLabel}</label>
              <Select
                size="large"
                style={{ width: "100%", borderRadius: 10 }}
                placeholder={t.eventTypePlaceholder}
                defaultValue={this.props.data?.EventTypeID}
                onChange={(value) =>
                  this.setState({
                    formData: { ...this.state.formData, EventTypeID: value },
                  })
                }
              >
                {this.state.eventTypes.map((et, i) => (
                  <Select.Option key={`et${i}`} value={et.EventTypeID}>
                    {et.EventTypeName}
                  </Select.Option>
                ))}
              </Select>
              <button
                style={{ ...submitBtn, marginTop: 24 }}
                onClick={() => {
                  if (!this.state.formData?.EventPlaylistName)
                    return message.error(t.errNoName);
                  if (!this.state.formData?.EventTypeID)
                    return message.error(t.errNoEventType);
                  this.next();
                }}
              >
                {t.next}
              </button>
            </div>
          );
        }
      }
    };

    return (
      <div style={bleed}>
        {/* Gradient header */}
        <div
          style={{
            background: "linear-gradient(135deg,#f59e0b 0%,#d97706 100%)",
            padding: "28px 40px 24px",
            textAlign: "center",
            color: "#fff",
          }}
        >
          <div
            style={{
              width: 52,
              height: 52,
              borderRadius: 14,
              background: "rgba(255,255,255,0.2)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              margin: "0 auto 12px",
            }}
          >
            <Zap size={26} color="#fff" />
          </div>
          <div style={{ fontSize: 20, fontWeight: 700, marginBottom: 4 }}>
            {stepHeaders[currentStep].title}
          </div>
          <div style={{ fontSize: 13, color: "rgba(255,255,255,0.80)" }}>
            {stepHeaders[currentStep].subtitle}
          </div>
          {/* Step indicators */}
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              gap: 8,
              marginTop: 18,
            }}
          >
            {[0, 1, 2, 3].map((i) => (
              <div
                key={i}
                style={{
                  width: i === currentStep ? 24 : 8,
                  height: 8,
                  borderRadius: 4,
                  background:
                    i <= currentStep ? "#fff" : "rgba(255,255,255,0.35)",
                  transition: "all 0.3s ease",
                }}
              />
            ))}
          </div>
        </div>
        {renderStepContent()}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    userdata: state.userdata,
    usertoken: state.usertoken,
    selectedBrandData: state.selectedBrandData,
    selectedBranchData: state.selectedBranchData,
  };
};

const ConnectedCreateScreenEventPage = connect(mapStateToProps, {
  requestServerGet,
  requestServerPost,
  selectPage,
  requestNodeServerPost,
})(CreateScreenEventPage);

const CreateScreenEventPageWithLang = (props) => {
  const { lang } = useProLanguage();
  const t =
    PRO_TRANSLATIONS[lang]?.createScreenEvent ||
    PRO_TRANSLATIONS.en.createScreenEvent;
  return <ConnectedCreateScreenEventPage langT={t} {...props} />;
};

export default CreateScreenEventPageWithLang;
